export default __webpack_public_path__ + "static/media/seguro-por-discapacidad.2abc1dfc.svg";